
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collage/[slug]",
      function () {
        return require("private-next-pages/collage/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collage/[slug]"])
      });
    }
  